// @ts-nocheck
import PropTypes from "prop-types";
import {useLayoutEffect, useRef, useState} from "react";
import NumberGrid from "./NumberGrid";

const boardContainerCls =
  "max-w-full w-fit h-auto flex flex-col relative p-0 overflow-visible max-md:w-full max-md:gap-1 max-md:min-h-0 max-md:mx-auto max-md:overflow-hidden max-md:justify-start max-md:items-center";
const scaledContentCls = "scale-100 origin-top w-fit";

/**
 * RouletteBoardOneOhOne - Reusable betting board component for 101-animal lottery games
 *
 * This component renders a roulette-style betting board with 101 animals (0, 99, 00, 1-98)
 * and various betting options (colors, even/odd, dozens, columns, ranges).
 *
 * Supports multiple games through the gameIdString prop.
 *
 * @param {string} gameIdString - The game identifier (e.g., 'lottery-101')
 * @param {function} onBetClick - Callback when a bet is placed
 * @param {array} placedBets - Array of currently placed bets
 * @param {number} maxBetPerOption - Maximum bet amount per option
 * @param {function} onMaxBetReached - Callback when max bet is reached
 * @param {boolean} isDeletionMode - Whether the board is in deletion mode
 */
const RouletteBoardOneOhOne = ({
  gameIdString,
  onBetClick,
  placedBets,
  maxBetPerOption = 1000,
  onMaxBetReached,
  isDeletionMode = false,
  figures = [], // New prop for API figures
}) => {
  const scaledRef = useRef(null);
  const containerRef = useRef(null);
  const [dims, setDims] = useState({height: undefined, width: undefined});

  // Dynamically set the container height to the scaled content height so that
  // the outer container collapses exactly to what is visually rendered.
  useLayoutEffect(() => {
    function measure() {
      if (!scaledRef.current) return;
      const rect = scaledRef.current.getBoundingClientRect();
      setDims({height: rect.height, width: rect.width});
    }
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [placedBets?.length]);

  return (
    <div
      className={boardContainerCls}
      ref={containerRef}
      style={{height: dims.height}}
    >
      <div
        className={scaledContentCls}
        ref={scaledRef}
      >
        {/* Number Grid Only - 5 columns with 3 special numbers at top */}
        <NumberGrid
          gameIdString={gameIdString}
          onNumberClick={onBetClick}
          placedBets={placedBets}
          maxBetPerOption={maxBetPerOption}
          onMaxBetReached={onMaxBetReached}
          isDeletionMode={isDeletionMode}
          figures={figures}
        />
      </div>
      {/* end scaledContent */}
    </div>
  );
};

RouletteBoardOneOhOne.propTypes = {
  gameIdString: PropTypes.string.isRequired,
  onBetClick: PropTypes.func,
  placedBets: PropTypes.arrayOf(
    PropTypes.shape({
      animalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      animalName: PropTypes.string,
      fichas: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.number,
          name: PropTypes.string,
        })
      ),
    })
  ),
  onRemoveFicha: PropTypes.func,
  maxBetPerOption: PropTypes.number,
  onMaxBetReached: PropTypes.func,
  isDeletionMode: PropTypes.bool,
  figures: PropTypes.arrayOf(PropTypes.object),
};

export default RouletteBoardOneOhOne;
